import { render, staticRenderFns } from "./ErrorPageIndexComponent.vue?vue&type=template&id=bb6d0c86"
import script from "./ErrorPageIndexComponent.vue?vue&type=script&lang=js"
export * from "./ErrorPageIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports